import { AnimatedMessaging } from 'signup-components/styles/MessagingAnimations.styles';
import { ImageBlob } from '../blob-messaging/ImageBlob';
import { useOnImageLoaded } from '../images/useOnImageLoaded';
import { BaseMessageCaption } from './BaseMessageCaption';
import { getMessage } from './MESSAGE';
import { isTransitionAndAnimationsDisabled } from '../selenium/seleniumFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MessageBlobCaption = ({
  messageKey
}) => {
  const {
    imageUrl,
    imageHeight,
    subImage
  } = getMessage(messageKey);
  const {
    imageLoaded,
    handleImageLoaded
  } = useOnImageLoaded(imageUrl);
  return /*#__PURE__*/_jsx(AnimatedMessaging, {
    disable: isTransitionAndAnimationsDisabled(),
    loaded: imageLoaded,
    children: /*#__PURE__*/_jsxs(BaseMessageCaption, {
      messageKey: messageKey,
      children: [/*#__PURE__*/_jsx(ImageBlob, {
        imageHeight: imageHeight,
        messageKey: messageKey,
        onImageLoaded: handleImageLoaded
      }), subImage]
    })
  });
};
export default MessageBlobCaption;